import { useState, useEffect } from "react";
import Course from "../types/Course";
import {
  addNewCourse,
  getAllCourses,
  updateCourse as updateCourseAPI,
  deleteCourse as deleteCourseAPI,
} from "../services/definitionsService";

export function useCourses() {
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const coursesData = await getAllCourses();
      setCourses(coursesData);
    } catch (err) {
      setError("Failed to fetch courses.");
    } finally {
      setLoading(false);
    }
  };

  const addCourse = async (title: string) => {
    const newCourse: Course = {
      courseId: "", // let backend generate ID
      course: title,
    };

    try {
      const response = await addNewCourse(newCourse); // backend creates and returns new course
      const saved = response.course;
      setCourses((prev) => [...prev, saved]);
    } catch (err) {
      console.error("Failed to add course:", err);
      setError("Failed to add course.");
    }
  };

  const updateCourse = async (id: string, title: string) => {
    const updatedCourse: Course = {
      courseId: id,
      course: title,
    };

    try {
      const response = await updateCourseAPI(updatedCourse); // backend updates and returns saved item
      const saved = response.course;

      setCourses((prev) =>
        prev.map((course) => (course.courseId === id ? saved : course))
      );
    } catch (err) {
      console.error("Failed to update course:", err);
      setError("Failed to update course.");
    }
  };

  const deleteCourse = async (id: string) => {
    try {
      await deleteCourseAPI(id);
      setCourses((prev) => prev.filter((course) => course.courseId !== id));
    } catch (err: any) {
      console.error("Failed to delete course:", err);
      setError("Failed to delete course: " + err.response.data.error);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  return {
    courses,
    loading,
    error,
    fetchCourses,
    addCourse,
    updateCourse,
    deleteCourse,
  };
}
